<template>
  <!-- 床位视图 -->
  <el-container style="background: #fff; padding: 10px">
    <el-header>
      <span style="margin-left:20px">正式入住:{{ Number(checkIn) + Number(tryIn)}}人</span>
      <span style="margin-left:20px">空床:{{ nullBed }}张</span>
      <span style="margin-left:20px">已预约:{{ order }}张</span>
      <span style="margin-left:30px">楼栋:</span>
      <el-select
        v-model="buildName"
        placeholder="请选择"
        class="small"
        @change="selectdialogShow"
      >
        <el-option
          v-for="item in BuilList"
          :key="item.buildingId"
          :label="item.buildingName"
          :value="item.buildingId"
        ></el-option>
      </el-select>
      <el-checkbox v-model="isShowName" border >显示姓名</el-checkbox>
      <img
        src="@/assets/beadhouse/nan.png"
        style="display:inline-block;vertical-align:middle;margin-left:30px;"
      />
      <span>男</span>
      <img
        src="@/assets/beadhouse/nv.png"
        style="display:inline-block;vertical-align:middle;margin-left:20px;"
      />
      <span>女</span>
      <img
        src="@/assets/beadhouse/kongchuang_icon.png"
        style="display:inline-block;vertical-align:middle;margin-left:20px;"
      />
      <span>空床</span>
      <img
        src="@/assets/beadhouse/yiyuyue.png"
        style="display:inline-block;vertical-align:middle;margin-left:20px;"
      />
      <span>已预约</span>
    </el-header>
    <el-main>
      <el-row v-for="(item, index) in floorList" :key="index">
        <fieldset
          style="border:none;border-top:1px solid #e2e2e2;font-size:16px"
        >
          <legend>{{ item.floorNo }}楼</legend>
        </fieldset>
        <div
          v-for="items1 in item.roomList"
          :key="items1.roomId"
          @mouseover="hoverIndex = items1.roomId;"
          @mouseout="hoverIndex = -1;"
          :class="{ hoverBg: typeOne == 1 && items1.roomId == hoverIndex }"
          style="float:left;margin:0px 20px;height:200px"
          @click="roomClick(items1);"
        >
          <div
            style="margin:0px 2px;height:170px;float:left;border:1px solid #EFEEF3;float:left;"
            v-for="(items2, index2) in items1.pageList"
            :key="index2"
          >
            <div
              v-for="(items3, index3) in items2.bedList"
              :key="index3"
              :class="{ borderred: typeTwo == 2 && index3 != 3 }"
            >
              <img
                :src="items3.src"
                style="margin:5px;cursor:pointer;"
                :class="{ borderred2: typeTwo == 2 && index3 != 3 }"
                @click="bedClick(items1, items3);"
              />
              <p v-if="isShowName" class="oldname">{{items3.oldName}}</p>
            </div>
          </div>
          <p
            style="font-size: 13px;margin-top: 180px;display: flex;align-items: center;justify-content: center;margin-right:25%"
          >
            {{ items1.roomno }}
          </p>
        </div>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
//床位视图
// import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
// import axios from "axios";
export default {
  name: "RoomView",
  data() {
    return {
      checkIn: 0,
      nullBed: 0,
      order: 0,
      tryIn: 0,
      buildId: 0,
      BuilList: [],
      currentFloorList: [],
      floorList: [],
      buildName: "",
      selectRoomtype: 0,
      typeOne: 1,
      isShowName:false,
      typeTwo: 2,
      hoverIndex: -1
    };
  },
  methods: {
    /* 
      获取入住信息
    */
    getIntoDetail() {
      this.$postJson("omc/Bed/queryBedStatus/" + this.buildId).then(res => {
        //初始化床位数量
        (this.checkIn = "0"),
          (this.nullBed = "0"),
          (this.order = "0"),
          (this.tryIn = "0"),
          console.log(res);
        for (var i = 0; i < res.result.length; i++) {
          if (res.result[i].status == 0) {
            this.nullBed = res.result[i].count;
          } else if (res.result[i].status == 5) {
            this.tryIn = res.result[i].count;
          } else if (res.result[i].status == 2) {
            this.checkIn = res.result[i].count;
          } else if (
            res.result[i].status == 3 ||
            res.result[i].status == 4 ||
            res.result[i].status == 6
          ) {
            this.order = Number(this.order) + Number(res.result[i].count);
          }
        }
      });
    },

    //获取楼栋信息
    getfloor() {
      this.$postForm("omc/Building/showAlls").then(res => {
        this.BuilList = res.result;
        this.buildName = res.result[0].buildingName; //初始化房间楼栋
        this.buildId = res.result[0].buildingId;
        this.getBuildFloorList();
        this.getIntoDetail();
      });
    },
    //选择房间床位弹窗显示
    selectdialogShow(val) {
      this.buildId = val;
      this.getBuildFloorList();
      this.getIntoDetail();
    },
    getBuildFloorList() {
      this.$postForm("omc/Room/showAll", { buildingId: this.buildId }).then(
        res => {
          if (res.result) {
            this.currentFloorList = res.result.floorList;
          } else {
            this.currentFloorList = [];
          }

          this.controlFloorData();
        }
      );
    },
    //处理楼层全部数据
    controlFloorData() {
      //为了一个房间太多床位的显示异常
      let floorList = [];
      for (let i = 0; i < this.currentFloorList.length; i++) {
        let roomList = [];
        //获取房间列表
        for (let j = 0; j < this.currentFloorList[i].roomList.length; j++) {
          let pageList = [];
          this.currentFloorList[i].roomList[j] = this.getBedSrc(
            this.currentFloorList[i].roomList[j]
          );
          let allBedList = this.currentFloorList[i].roomList[j].bedList;
          //切割数组,然后进行分页添加上去
          for (var k = 0; k < allBedList.length; k += 4) {
            var bedList = allBedList.slice(k, k + 4);
            pageList.push({
              bedList: bedList
            });
          }
          let roomData = {
            roomno: this.currentFloorList[i].roomList[j].roomNo,
            roomId: this.currentFloorList[i].roomList[j].roomId,
            roomType: this.currentFloorList[i].roomList[j].roomType,
            pageList: pageList
          };
          roomList.push(roomData);
        }

        let floorData = {
          floorNo: this.currentFloorList[i].floorNo,
          roomList: roomList
        };
        floorList.push(floorData);
      }
      this.floorList = floorList;
      this.roomBeddialogVisible = true;
    },
    //根据房间和床位,设置它的src,如果需要修改显示的逻辑,请修改这里
    getBedSrc(roomData) {
      var bedList = roomData.bedList;
      roomData.bedList.forEach(bedItem => {
        //试入住
        if (bedItem.status == 5) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/nv.png");
          }
        }

        //入住
        if (bedItem.status == 2) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/nv.png");
          }
        }

        //预约
        if (bedItem.status == 3 || bedItem.status == 4) {
          console.log(bedItem, "656565656565656");
          bedItem.src = require("@/assets/beadhouse/yiyuyue.png");
          console.log(bedItem.src);
        }

        //空床
        if (bedItem.status == 0) {
          bedItem.src = require("@/assets/beadhouse/kongchuang_icon.png");
        }

        //待缴费
        if (bedItem.status == 7) {
          if (bedItem.sex == 0) {
            bedItem.src = require("@/assets/beadhouse/daijiaofei_nan.png");
          } else {
            bedItem.src = require("@/assets/beadhouse/daijiaofei_nv.png");
          }
        }

        //调房调级中
        if (bedItem.status == 6) {
          bedItem.src = require("@/assets/beadhouse/tiaozhengzhong_nan.png");
        }
      });
      return roomData;
    }
  },
  mounted() {
    this.getfloor();
  },
  computed: {}
};
</script>
<style scoped>
.small {
  width: 120px;
}
.borderred {
  border-bottom: 1px solid #efeef3;
}
.borderred2 {
  border-bottom: 1px solid #efeef3;
}
.oldname{
  position: relative;
  top: -24px;
  height: 0px;
  width: 78px;
  text-align: center;
  font-size: 10px;
}
</style>
